import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import Loading from "../loading";
import axios from "axios";
import Slider, { SliderTooltip } from "rc-slider";
import { BsCloudUpload } from "react-icons/bs";
import { FaEquals } from "react-icons/fa";
import { FcApproval } from "react-icons/fc";
import { useMediaQuery } from "@chakra-ui/media-query";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import CSVReader from "react-csv-reader";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DateTimePicker from "react-datetime-picker";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import PresaleGeneralBNBABI from "../../utils/presaleGeneralBNBABI.json";
import Environment from "../../utils/Environment";
import { Grid, Box, Avatar, Container } from "@material-ui/core";
import { Button, Input } from "@chakra-ui/react";
const useStyles = makeStyles((theme) => ({
  progressDone: {
    borderRadius: "20px",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "0",
    opacity: 0,
    fontSize: "12px",
    transition: "1s ease 0.3s",
    background: "#00B7C5",
  },
  progress: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    position: "relative",
    margin: "15px 0",
    height: "10px",
    width: "100%",
  },
  orange: {
    color: "#fff",
    backgroundColor: "tranparent",
    border: "3px solid #00B7C5",
    // padding: "40px",
    width: "100px",
    height: "100px",

    overflow: "visible",
    zIndex: 100,
    position: "relative",
    "& img": {
      borderRadius: "100%",
      position: "relative",
      zIndex: 20,
    },
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.6s infinite ease-in-out",
      border: "2px solid #00B7C5",
      content: '""',
      zIndex: 10,
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.6)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(1.4)",
      opacity: 0,
    },
  },
}));

const Sales = () => {
  const classes = useStyles();
  const { Handle } = Slider;
  const {
    userWalletAddress = "",
    network = "",
    bnbBalance = 0,
    salesContract = "",
    web3,
    data = [],
  } = useSelector((state) => state.UserReducer);
  const [style, setStyle] = React.useState({});
  const [remaining, setremaining] = useState(0);
  const [yourBNDBalance, setyourBNDBalance] = useState(0);

  const [loading, setloading] = useState(false);
  const [maximumContribution, setmaximumContribution] = useState(0);
  const [yourContribution, setyourContribution] = useState(0);
  const [owner, setowner] = useState("");
  const [allow, setallow] = useState("");
  const [buyContract, setbuyContract] = useState("");
  const [amount, setamount] = useState("");
  const [tokenBalance, settokenBalance] = useState(0);
  const [soldToken, setsoldToken] = useState(0);
  const [participant, setparticipant] = useState(0);
  const [yourToken, setyourToken] = useState(0);
  const [claim, setclaim] = useState(false);
  const [time, settime] = useState("");
  const [countTime, setCountDateTime] = React.useState({
    time_days: 0,
    time_Hours: 0,
    time_Minusts: 0,
    time_seconds: 0,
  });
  let params = useParams();
  const [arr, setarr] = React.useState([]);

  const { id } = params;
  useEffect(() => {
    const init = async () => {
      var datafinal = data.find(({ _id }) => _id == id);
      setarr(datafinal);
    };
    if (data) {
      init();
    }
  }, [data]);

  const { spacing } = useTheme();
  React.useEffect(() => {
    setTimeout(() => {
      const newStyle = {
        opacity: 0.8,
        width: `${remaining}%`,
        fontSize: "10px",
      };

      setStyle(newStyle);
    }, 200);
  }, [remaining]);
  useEffect(() => {
    const init = async () => {
      setyourBNDBalance(bnbBalance.toFixed(4));
      const contractAddress = await salesContract.methods
        .getPreSale(userWalletAddress, arr.tokenAddress)
        .call();
      console.log(contractAddress);

      const contract = await new web3.eth.Contract(
        PresaleGeneralBNBABI,
        contractAddress
      );
      setbuyContract(contract);
      const tokenBalance = await contract.methods
        .getContractTokenBalance()
        .call();

      const decimal = Math.pow(10, +arr.tokenDecimel);
      settokenBalance(tokenBalance / decimal);
      const soldTokens = await contract.methods.soldTokens().call();
      const nextClaimTime = await contract.methods.nextClaimTime().call();
      const preSaleTime = await contract.methods.preSaleTime().call();
      settime(+preSaleTime + +nextClaimTime);
      setsoldToken(soldTokens / decimal);
      var remaining = (soldTokens / tokenBalance) * 100;
      console.log(remaining);
      setremaining(remaining);
      const participants = await contract.methods.totalUser().call();
      setparticipant(participants);
      if (userWalletAddress) {
        const userToken = await contract.methods
          .userTokenBalance(userWalletAddress)
          .call();
        setyourToken(+userToken / +decimal);
        const yourContribution = await contract.methods
          .userContribution(userWalletAddress)
          .call();
        setyourContribution(web3.utils.fromWei(yourContribution));
      }
      const maxAmount = await contract.methods.maxAmount().call();
      setmaximumContribution(web3.utils.fromWei(maxAmount));
      const tokenOwner = await contract.methods.tokenOwner().call();
      const allow = await contract.methods.allow().call();
      // const claimStat = await contract.methods.canClaim().call();
      // setclaimStatus(claimStat);
      setallow(!allow);
      setowner(tokenOwner);
    };
    if (arr.length !== 0 && data && salesContract) {
      init();
    }
  }, [salesContract, arr, data, userWalletAddress]);
  const claimHandler = () => {
    if (!userWalletAddress) {
      toast.error("Error! please connect your wallet");
    } else if (yourContribution == 0) {
      toast.error("Error! You did notcontributein this presale.");
    } else {
      setloading(true);

      buyContract.methods
        .claim()
        .send({
          from: userWalletAddress,
        })
        .then(() => {
          toast.success("Success! claim confirmed.");
          window.location.reload();
          setloading(false);
        })
        .catch((error) => {
          toast.error(error.message);
          setloading(false);
        });
    }
  };
  const withdrawAndInitializePool = () => {
    setloading(true);
    buyContract.methods
      .withdrawAndInitializePool()
      .send({ from: userWalletAddress })
      .then(() => {
        toast.success(
          "Success! Withdrawal and initialization successfuly completed."
        );
        setloading(false);
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error.message);
        setloading(false);
      });
  };
  const AllowHandler = () => {
    setloading(true);
    buyContract.methods
      .setAllow(allow)
      .send({ from: userWalletAddress })
      .then(() => {
        toast.success(
          `Success! Presale ${allow ? "Ended" : "Started"} Successfully.`
        );
        setloading(false);
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error.message);
        setloading(false);
      });
  };
  const scheduleHandler = () => {
    setloading(true);
    buyContract.methods
      .startNextCycle()
      .send({ from: userWalletAddress })
      .then(() => {
        toast.success("Success! Next schedule successfully started.");
        setloading(false);
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error.message);
        setloading(false);
      });
  };
  const contStartTimerStart = (time) => {
    let countDownDate = moment.unix(time).format("x");

    const interval = setInterval(async () => {
      const now = new Date().getTime();
      const distance = +countDownDate - +now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minuts = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (Number(distance) < 0) {
        clearInterval(interval);
        setclaim(true);
      } else {
        setCountDateTime({
          ...countTime,
          time_days: days,
          time_Hours: hours,
          time_Minusts: minuts,
          time_seconds: seconds,
        });
      }
    }, 1000);
  };
  useEffect(() => {
    if (time && yourContribution > 0) {
      contStartTimerStart(time);
    }
  }, [time, yourContribution]);
  return (
    <>
      <Container maxWidth="sm">
        <Box
          borderRadius="10px"
          bgcolor="#EDFAFB"
          border="2px solid #00B7C5"
          px={spacing(1)}
          py={spacing(0.2)}
          my={10}
          position="relative"
        >
          {owner && userWalletAddress.toLowerCase() == owner.toLowerCase() && (
            <Box position="absolute" right="5%" top="5%">
              <Button
                bg="#00B7C5"
                color="white"
                width={["100%"]}
                style={{ marginBottom: "40px" }}
                onClick={withdrawAndInitializePool}
              >
                End Presale
              </Button>
            </Box>
          )}
          {owner &&
            userWalletAddress.toLowerCase() == owner.toLowerCase() &&
            claim && (
              <Box position="absolute" right="5%" top="35%">
                <Button
                  bg="#00B7C5"
                  color="white"
                  width={["100%"]}
                  style={{ marginBottom: "40px" }}
                  onClick={scheduleHandler}
                >
                  Start Next Schedule
                </Button>
              </Box>
            )}
          {userWalletAddress.toLowerCase() ==
            Environment.defaultAddress.toLowerCase() && (
            <Box position="absolute" right="5%" top="20%">
              <Button
                bg="#00B7C5"
                color="white"
                width={["100%"]}
                onClick={AllowHandler}
              >
                {allow ? "Start" : "Stop"} Presale
              </Button>
            </Box>
          )}
          <Box display="flex">
            <Box component="h3" fontSize={spacing(2.5)} pt={spacing(0.2)}>
              <Avatar className={classes.orange} src={arr.logoLink}></Avatar>
            </Box>

            <Box component="h3" fontSize={spacing(2.5)} ml={spacing(0.3)}>
              {arr.projectName} <br />
              <a
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
                textDecoration="none"
                href={arr.webLink}
              >
                <Box
                  component="span"
                  p={spacing(0.1)}
                  borderRadius="100%"
                  bgcolor="secondary.main"
                  fontSize={spacing(2)}
                  className="fas fa-globe"
                ></Box>
              </a>
              <a
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
                textDecoration="none"
                href={arr.twitterLink}
              >
                <Box
                  component="span"
                  ml={spacing(0.1)}
                  p={spacing(0.1)}
                  borderRadius="100%"
                  bgcolor="secondary.main"
                  fontSize={spacing(2)}
                  className="fab fa-twitter"
                ></Box>
              </a>
              <a
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
                textDecoration="none"
                href={arr.telegramLink}
              >
                <Box
                  component="span"
                  ml={spacing(0.1)}
                  p={spacing(0.1)}
                  borderRadius="100%"
                  bgcolor="secondary.main"
                  fontSize={spacing(2)}
                  className="fab fa-telegram-plane"
                ></Box>
              </a>
              <a
                target="_blank"
                style={{ textDecoration: "none", color: "#fff" }}
                textDecoration="none"
                href={arr.githubLink}
              >
                <Box
                  component="span"
                  ml={spacing(0.1)}
                  p={spacing(0.1)}
                  borderRadius="100%"
                  bgcolor="secondary.main"
                  fontSize={spacing(2)}
                  className="fab fa-github"
                ></Box>
              </a>
              <Box
                component="p"
                borderRadius="20px"
                align="left"
                display="flex"
                alignItems="center"
                justifyContent="center"
                p={spacing(0.1)}
                color="white"
                fontSize={spacing(1.6)}
                bgcolor="secondary.main"
                my={1}
                style={{ textTransform: "capitalize" }}
              >
                <Box
                  component="span"
                  // ml={spacing(0.05)}
                  mr={spacing(0.1)}
                  fontSize={spacing(2)}
                  className="fas fa-dot-circle"
                ></Box>
                {arr.projectStatus}
              </Box>
              <Box
                component="p"
                borderRadius="20px"
                align="left"
                display="flex"
                alignItems="center"
                justifyContent="center"
                p={spacing(0.1)}
                color="white"
                fontSize={spacing(1.6)}
                bgcolor="secondary.main"
                my={1}
                style={{ textTransform: "capitalize" }}
              >
                <Box
                  component="span"
                  // ml={spacing(0.05)}
                  mr={spacing(0.1)}
                  fontSize={spacing(2)}
                  className="fas fa-dot-circle"
                ></Box>
                {arr.fileData && arr.fileData.length !== 0
                  ? "Private"
                  : "Public"}
              </Box>
            </Box>
          </Box>
          <Box
            component="h3"
            color="text.secondary"
            align="left"
            fontSize={spacing(2)}
            my={spacing(0.2)}
            ml={spacing(0.3)}
          >
            {arr.projectDescription}
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
          >
            <Box
              component="h3"
              color="#999"
              fontSize={spacing(1.6)}
              fontWeight={500}
              ml={spacing(0.3)}
            >
              Liquidity Allocation
              <br />
              <Box
                component="h3"
                color="secondary.main"
                fontSize={spacing(4)}
                my={0}
              >
                {arr.liquidityPercent}%
              </Box>
            </Box>
            <Box
              component="h3"
              color="#999"
              fontSize={spacing(1.6)}
              fontWeight={500}
              ml={spacing(0.3)}
            >
              Hard Cap <br />
              <Box
                component="h3"
                color="secondary.main"
                fontSize={spacing(4)}
                my={0}
              >
                {arr.hardCap}
              </Box>
            </Box>
            <Box
              component="h3"
              color="#999"
              fontSize={spacing(1.6)}
              fontWeight={500}
              ml={spacing(0.3)}
            >
              Soft Cap <br />
              <Box
                component="h3"
                color="secondary.main"
                fontSize={spacing(4)}
                my={0}
              >
                {arr.softCap}
              </Box>
            </Box>
          </Box>
          <Box
            component="h3"
            color="#999"
            align="left"
            fontSize={spacing(1.6)}
            fontWeight={500}
            ml={spacing(0.3)}
            my={0}
          >
            Access{" "}
          </Box>
          <Box className={classes.progress} my={0}>
            <Box className={classes.progressDone} style={style}></Box>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            fontWeight={600}
            flexWrap="wrap"
          >
            <Box
              component="span"
              fontSize={spacing(2)}
              ml={spacing(0.3)}
              my={0}
            >
              {remaining.toFixed(2)}%
            </Box>
            <Box
              component="span"
              fontSize={spacing(2)}
              ml={spacing(0.3)}
              my={0}
            >
              {soldToken} {arr.tokenSymbol}/{tokenBalance} {arr.tokenSymbol}
            </Box>
          </Box>
        </Box>
      </Container>

      <Box my={spacing(0.2)}>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box
                borderRadius="10px"
                bgcolor="#EDFAFB"
                border="2px solid #00B7C5"
                p={spacing(0.5)}
              >
                <Box
                  component="h3"
                  align="left"
                  fontSize={spacing(3)}
                  my={2}
                  color="secondary.main"
                >
                  Start Date
                </Box>
                <Box component="h3" align="left" fontSize={spacing(2.5)} my={2}>
                  {moment.unix(arr.startTime / 1000).format("LLL")}
                </Box>
                <Box
                  component="h3"
                  align="left"
                  fontSize={spacing(3)}
                  my={2}
                  color="secondary.main"
                >
                  End Date
                </Box>
                <Box component="h3" align="left" fontSize={spacing(2.5)} my={2}>
                  {moment.unix(arr.endTime / 1000).format("LLL")}
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={8}>
              <Box
                borderRadius="10px"
                bgcolor="#EDFAFB"
                border="2px solid #00B7C5"
                p={spacing(0.5)}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexWrap="wrap"
                >
                  <Box component="h3" align="left" my={0}>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(3)}
                      my={2}
                      color="secondary.main"
                    >
                      Sale Price
                    </Box>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(2.5)}
                      my={2}
                    >
                      1 BNB = {arr.priceOfTokenOnSales} {arr.tokenSymbol}
                    </Box>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(3)}
                      my={2}
                      color="secondary.main"
                    >
                      IDO Hardcap
                    </Box>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(2.5)}
                      my={2}
                    >
                      {arr.hardcap}
                    </Box>
                  </Box>
                  <Box component="h3" align="right" my={0}>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(3)}
                      my={2}
                      color="secondary.main"
                    >
                      Token Ticker
                    </Box>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(2.5)}
                      my={2}
                    >
                      {arr.tokenSymbol}
                    </Box>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(3)}
                      my={2}
                      color="secondary.main"
                    >
                      Participants
                    </Box>
                    <Box
                      component="h3"
                      align="left"
                      fontSize={spacing(2.5)}
                      my={2}
                    >
                      {participant}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box my={spacing(2)}>
        <Container maxWidth="lg">
          <Grid container justify="center">
            <Grid item xs={12} md={8}>
              <Box
                borderRadius="10px"
                bgcolor="#EDFAFB"
                border="2px solid #00B7C5"
                p={spacing(0.5)}
              >
                {+yourContribution > 0 && (
                  <Box
                    component="h3"
                    align="center"
                    color="secondary.main"
                    fontSize={spacing(2.6)}
                    fontWeight={500}
                    ml={spacing(0.3)}
                  >
                    Next Claim Time &nbsp;&nbsp;{countTime.time_days}:
                    {countTime.time_Hours}:{countTime.time_Minusts}:
                    {countTime.time_seconds}
                  </Box>
                )}
                <Box
                  component="h3"
                  align="left"
                  className={classes.titleHeading}
                  fontSize={spacing(2)}
                  my={2}
                >
                  <Box
                    component="span"
                    color="secondary.main"
                    fontSize={spacing(2.6)}
                    fontWeight={500}
                    ml={spacing(0.3)}
                  >
                    {" "}
                    Claimable Tokens:
                  </Box>{" "}
                  <Box
                    component="span"
                    color="#000"
                    align="center"
                    fontSize={spacing(3)}
                    my={0}
                  >
                    {yourToken}
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  px={spacing(0.5)}
                >
                  <Box
                    component="h3"
                    color="secondary.main"
                    fontSize={spacing(2.6)}
                    fontWeight={500}
                    ml={spacing(0.3)}
                  >
                    Your Balance
                    <br />
                    <Box
                      component="h3"
                      color="#000"
                      align="center"
                      fontSize={spacing(3)}
                      my={0}
                    >
                      {yourBNDBalance} {arr.type}
                    </Box>
                  </Box>

                  <Box
                    component="h3"
                    color="secondary.main"
                    fontSize={spacing(2.6)}
                    fontWeight={500}
                    ml={spacing(0.3)}
                  >
                    Your maximum Contribution
                    <br />
                    <Box
                      component="h3"
                      color="#000"
                      align="center"
                      fontSize={spacing(3)}
                      my={0}
                    >
                      {maximumContribution} {arr.type}
                    </Box>
                  </Box>
                </Box>
                <Box className={classes.progress} my={0}>
                  <Box className={classes.progressDone} style={style}></Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  px={spacing(0.5)}
                >
                  <Box
                    component="h3"
                    color="secondary.main"
                    fontSize={spacing(2.6)}
                    fontWeight={500}
                    ml={spacing(0.3)}
                  >
                    Your Contribution
                    <br />
                    <Box
                      component="h3"
                      color="#000"
                      align="center"
                      fontSize={spacing(3)}
                      my={0}
                    >
                      {yourContribution} {arr.type}
                    </Box>
                  </Box>

                  <Box
                    component="h3"
                    color="secondary.main"
                    fontSize={spacing(2.6)}
                    fontWeight={500}
                    ml={spacing(0.3)}
                  >
                    Remaining Contribution
                    <br />
                    <Box
                      component="h3"
                      color="#000"
                      align="center"
                      fontSize={spacing(3)}
                      my={0}
                    >
                      {maximumContribution - yourContribution} {arr.type}
                    </Box>
                  </Box>
                </Box>
                <Box component="h3" align="center" mt={spacing(1)}>
                  <Button
                    disabled={!claim}
                    bg="#00B7C5"
                    color="white"
                    width={[
                      "20%", // base
                      "20%", // 480px upwards
                      "20%", // 768px upwards
                      "20%", // 992px upwards
                    ]}
                    onClick={claimHandler}
                  >
                    Claim
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Sales;
